module.exports = __webpack_public_path__ + "img/icon-clear.a74c3578.svg";